<template>
  <div class="sub-page">
    <div class="sub-page-title">
      安全中心
    </div>
    <div class="sub-page-item">
      <div class="sub-page-item-title">
        <span class="main">账户密码</span>
      </div>
      <Button
        type="text"
        @click="go(`/user/safe/edit-password`)">
        修改
      </Button>
    </div>
    <div class="sub-page-item">
      <div class="sub-page-item-title">
        <span class="main">登录手机号码</span>
        <span class="sub">已绑定手机号码 {{ mobile | encrypt }}</span>
      </div>
      <Button
        type="text"
        @click="go(`/user/safe/edit-mobile`)">
        修改
      </Button>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    mobile() {
      const mobile = this.$store.state.user.userAuth.identifier;
      return mobile;
    },
  },
  filters: {
    encrypt(v) {
      if (v) {
        return v.substr(0, 4) + '****' + v.substr(7, 4);
      }
      return v;
    },
  },
  methods: {
    go(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style lang="scss" scoped>
.sub-page {
  flex: 1;
  &-title {
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 20px;
  }
  &-item {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f4f4f4;
    &-title {
      display: flex;
      flex-direction: column;
      .main {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.85);
      }
      .sub {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.45);
      }
    }
    .ivu-btn {
      font-size: 12px;
      color: #1890ff;
      &.current {
        color: rgba(0, 0, 0, 0.45);
      }
    }
  }
}
</style>
